module.exports = __webpack_public_path__ + "images/organization/purple-face.ee0f268b424c09fdf633.svg";